export default __webpack_public_path__ + "static/media/chat.0faf27c1.svg";